
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epoch/terms",
      function () {
        return require("private-next-pages/epoch/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epoch/terms"])
      });
    }
  